<template>
  <div ref="domRef" class="base-card-info">
    <div class="info-card-title">
      开户许可证信息
    </div>
    <div class="base-info-list">
      <div class="left-list gap-y-[14px]">
        <div class="item">
          <div class="label">
            对公账户名
          </div>
          <div class="value">
            {{ baseInfo.serverLicense?.accountName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            纳税人识别号
          </div>
          <div class="value">
            {{ baseInfo.serverLicense?.creditCode }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            开票地址
          </div>
          <div class="value">
            {{ baseInfo.serverLicense?.address }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            银行预留手机号
          </div>
          <div class="value">
            {{ baseInfo.serverLicense?.phoneNo }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            开户银行
          </div>
          <div class="value">
            {{ baseInfo.serverLicense?.bankName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            银行账号
          </div>
          <div class="value">
            {{ baseInfo.serverLicense?.bankAccount }}
          </div>
        </div>
      </div>
      <div class="right-list">
        <div class="item">
          <div class="label">
            银行开户许可证
          </div>
          <div class="value">
            <div class="business-license-box">
              <img
                :src="baseInfo.serverLicense?.licenseUrl"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IServerMergeInfo } from '@core/main/types';
import { useElementImgPreview } from '@vue3/components';
import { inject, ref } from 'vue';

defineOptions({ name: 'LicenceInfo' }); // 账户中心 - 开户许可证信息

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

const baseInfo = inject('baseInfo') as IServerMergeInfo;
</script>
